<template>
  <v-flex xs12>
    <v-card class="e-cardLeccion e-elevation--4 e-border--radius">
      <v-card-title class="text-xs-center pt-3 px-2 justify-center pb-0">
        <h4 class="e-subTitle grey-light--text">Lección {{ letra }}</h4>
        <!-- <img src="../../assets/images/unit/icongramatica.png" height="35"> -->
      </v-card-title>
      <v-card-text >
        <p class="e-description-big mb-0">{{ descripcion }}</p>
      </v-card-text>
      <v-card-actions class="px-5 pt-0 pb-3">
        <v-btn
        block
        round
        large
        router-link
        :to="`/gramatica/${id_unit}/${id_grammar}/leccion/${id_lesson}`"
        color="primary">
          COMENZAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    router: {
      type: String,
      default: ''
    },
    letra: {
      type: String,
      default: '1'
    },
    descripcion: {
      type: String,
      default: ''
    },
    id_unit: {
      type: String
    },
    id_grammar: {
      type: String
    },
    id_lesson: {
      type: String
    }
  }
}
</script>
